import { useToast } from '@lifebit-ai/lds'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { extractErrorMessage } from 'core/utils'
import { bulkUnassignDataAccessRequests } from 'services/data-access-requests'
import { DataAccessRequestQueryKeys } from 'services/data-access-requests/queryKeys'
import type { BulkUnassignDataAccessRequestsParams } from 'services/data-access-requests/types'
import { invalidateRequestActivityQueries } from 'services/request-activity/invalidateRequestActivityQueries'
import type { ApiErrorResponse } from 'services/types'
import { isAirlockRequestsV3RoutesEnabled } from 'utils/env'

interface UseBulkUnassignDataAccessRequestsParams {
  onSuccess?: () => void
}

export const useBulkUnassignDataAccessRequests = ({ onSuccess }: UseBulkUnassignDataAccessRequestsParams = {}) => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation<void, ApiErrorResponse, BulkUnassignDataAccessRequestsParams>({
    mutationFn: params => {
      if (!isAirlockRequestsV3RoutesEnabled()) {
        return Promise.resolve()
      }

      return bulkUnassignDataAccessRequests(params)
    },
    onSuccess: () => {
      toast({ message: 'Data access requests unassigned successfully' })
      queryClient.invalidateQueries({ queryKey: DataAccessRequestQueryKeys.All() })
      invalidateRequestActivityQueries(queryClient)
      onSuccess?.()
    },
    onError: error => {
      toast({ message: extractErrorMessage(error, 'Failed to unassign data access requests') })
    }
  })
}
